import GuidesLink from './GuidesLink';

export default GuidesLink;
